const awsmobile = {
    "aws_user_pools_web_client_id": "5kg050pr3l7vcb6t5tra8stn3k",
};


export default awsmobile;
